import {
  Card,
  CardSection,
  Image,
  Text,
  Group,
  SimpleGrid,
  Badge,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { fetchGalleryPublic } from "../api";

export default function StyleCard({ style }) {
  const [images, setImages] = useState(null);

  useEffect(() => {
    fetchGalleryPublic(1, 4, style.id).then((data) => {
      setImages(data);
    });
  }, [style.id]);

  let img = images && images.length > 0 && images[0];
  // Don't show a style for which we don't have a single image
  if (!img) return null;

  var subGallery = images.slice(1, 3);

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <CardSection>
        <Image
          alt={img.generateConfig?.prompt ?? img.slug}
          src={img.thumbnailUri}
          width={200}
        />
      </CardSection>

      {subGallery.length > 0 && (
        <CardSection inheritPadding mt="md">
          <SimpleGrid cols={3}>
            {subGallery.map((img) => (
              <Image
                key={img.id}
                alt={img.generateConfig?.prompt ?? img.slug}
                radius="sm"
                src={img.thumbnailUri}
                width={80}
              />
            ))}
          </SimpleGrid>
        </CardSection>
      )}

      <Group justify="space-between" mt="md" mb="xs">
        <Text fw={500}>{style.title}</Text>
      </Group>

      <Text size="sm" c="dimmed">
        {style.teaser}
      </Text>

      <Group gap="xs" mt="sm">
        {style.tags?.map((tag) => (
          <Badge variant="light" key={tag}>
            {tag}
          </Badge>
        ))}
      </Group>

      {/* <Button
        component={Link}
        to={`styles/${style.id}`}
        color="blue"
        fullWidth
        mt="md"
        radius="md"
      >
        Explore
      </Button> */}
    </Card>
  );
}
